export function renderBuildSortableHeaderDefTemplate({
  sortLabelExpr,
  sortableHeaderButtonJsx
}: {
  sortLabelExpr: string
  sortableHeaderButtonJsx: string
}): string {
  return `header: ({ column }) => {
      ${sortLabelExpr}
      return (
        ${sortableHeaderButtonJsx}
      )
    }`
}
